import user from './user'

export default {
  modules: {
    user
  }
}
